import api from '..'

export async function deleteTest(id: string): Promise<void> {
  await api.delete(`/flow_experiments/${id}`)
}
